const useGetRestaurants = async () => {
    let restaurants = [];

    var requestOptions = {
        method: 'GET',
        redirect: 'follow'
      };

    restaurants = await fetch('/.netlify/functions/getRestaurants', requestOptions)
        .then((data) => data.json())
        .then((data) => {
            return (data)
        });
    
    // console.log(restaurants, 'from here')
    return restaurants;
}

export default useGetRestaurants;